import { useId, type ReactNode } from "react";
import { PopoverBody, UncontrolledPopover } from "reactstrap";
import type { Client } from "features/Clients/types/client.types";
import { ClientDetails } from "./ClientInfoCard";

interface Props {
  client: Client;
  clientId: number | string;
  children: ReactNode;
}

export function ClientPopover({ client, clientId, children }: Props) {
  // reactstrap resolves `target` via querySelector, which rejects useId's colons.
  const targetId = `client-popover-${useId().replace(/:/g, "")}`;

  return (
    <>
      <span id={targetId}>{children}</span>
      <UncontrolledPopover
        target={targetId}
        trigger="hover focus"
        placement="bottom"
      >
        <PopoverBody>
          <ClientDetails client={client} clientId={clientId} />
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
}
